export default {"src":"/_next/static/media/hunting.afb877e8.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};